// angular import
import { Component, Input, NgModule } from '@angular/core';
import { NavigationItem } from '../../navigation';
import { Location } from '@angular/common';
// import { LanguageService } from 'src/app/multi-language/language.service';
import { TranslateService } from '@ngx-translate/core';
// import { ConfigurationsService } from '../../../configuration/service/configurations.service';
// import { TfService } from 'src/app/tf/service/tf.service';
import { environment } from 'src/environments/environment';
import { ConfigurationsService } from '../../../configuration/service/configurations.service';
import { FeatherModule } from 'angular-feather';
import { allIcons } from 'angular-feather/icons';
import { TfService } from 'src/app/tf/tf-service.service';
import { QuotationSettingService } from 'src/app/Theme/shared/service/quotation-setting/quotation-setting.service';

@Component({
  selector: 'app-nav-item',
  templateUrl: './nav-item.component.html',
  styleUrls: ['./nav-item.component.scss']
})
export class NavItemComponent {
  // public props
  @Input() item: NavigationItem;
  @Input() allowedPermissions: Record<string, boolean> | null = null;
  /** Phone band from `_fluid-scale.scss` `$fluid-vp-max` (430px). */
  @Input() isPhoneViewport = false;
  themeLayout: string;
  langset;
  themeConfig: { layout?: string } = { layout: 'vertical' };
  host = environment.apiUrlHost;
  name: string;
  element;
  isAdmin = false
  user
  quotationAllowed = false;
  quotationFeatureLoaded = false;
  // constructor
  constructor(
    private location: Location,
    public translate: TranslateService,
    private ConfigurationsService: ConfigurationsService,
    private tfService: TfService,
    private quotationSettingService: QuotationSettingService,
  ) {
    // this.langset = this.translate.getBrowserLang();
    // localStorage.setItem("lang", this.langset)
    this.ConfigurationsService.getConfig().subscribe((res) => {
      this.themeConfig = { layout: 'vertical', ...res };
      this.themeLayout = this.themeConfig.layout ?? 'vertical';
    });
    // Check if the user is admin when the component initializes
    // this.isAdmin = this.tfService.isAdmin(localStorage.getItem('token'));
  }
  // Method to check if item should be hidden for admin users
  isItemHiddenForAdmin(item: NavigationItem): boolean {
    return item.title === 'Configurations' && this.isAdmin;
  }

  /** True if item has no permission requirement or user has the required permission. Hide until loaded when item has permission to avoid flash. */
  isItemVisibleByPermission(item: NavigationItem): boolean {
    if (!item.permission) return true;
    if (this.allowedPermissions == null) return false; // still loading: hide permission-gated items until we know
    return this.allowedPermissions[item.permission] === true;
  }
  setUserTypeBasedOnToken(): void {
    const groups = this.tfService.getUserGroupsFromLocalStorage();
    this.user = groups.includes('admin') ? 'admin' : 'contact';
  }

  /** Hide quotation-gated nav rows until resolve completes, then when quotation is disabled. */
  isQuotationGatedItemVisible(item: NavigationItem): boolean {
    if (!item.requiresQuotationEnabled) {
      return true;
    }
    if (!this.quotationFeatureLoaded) {
      return false;
    }
    return this.quotationAllowed;
  }

  /** Fixed-navbar shortcuts: visible in the phone drawer only. */
  isItemVisibleOnViewport(item: NavigationItem): boolean {
    if (!item.mobileOnly) {
      return true;
    }
    return this.isPhoneViewport;
  }

  /** Extra visibility for customer portal nav rows (e.g. split dashboards by `adminCustomer`). */
  isContactPortalGroupFilterVisible(item: NavigationItem): boolean {
    if (this.user !== 'contact') return true;
    const groups = this.tfService.getUserGroupsFromLocalStorage();
    if (item.contactGroupsAny?.length) {
      return item.contactGroupsAny.some((g) => groups.includes(g));
    }
    if (item.contactGroupsNoneOf?.length) {
      return !item.contactGroupsNoneOf.some((g) => groups.includes(g));
    }
    return true;
  }
  ngOnInit(): void {
    this.quotationSettingService.isQuotationAllowed().subscribe((allowed) => {
      this.quotationAllowed = allowed;
      this.quotationFeatureLoaded = true;
    });
    this.setUserTypeBasedOnToken();
    let current_url = this.location.path();
    if (this.location['_baseHref']) {
      current_url = this.location['_baseHref'] + current_url;
    }
    const link = "a.nav-link[ href='" + current_url + "' ]";
    this.element = document.querySelector(link);
    this.closeOtherMenu();
  }
  // public method
  closeOtherMenu(event?: Event) {
    if ((this.themeConfig?.layout ?? 'vertical') === 'vertical') {
      if (event && event.target && (event.target as HTMLElement).matches('a.nav-link')) {
        this.element = event.target;
      }

      if (this.element !== null && this.element !== undefined) {
        let parent = this.element.parentElement;
        const sections = document.querySelectorAll('.pcoded-hasmenu');
        for (let i = 0; i < sections.length; i++) {
          sections[i].classList.remove('active');
          sections[i].classList.remove('pcoded-trigger');
        }

        do {
          // Move up to the parent element in each iteration
          parent = parent.parentElement;
          if (parent && parent.classList.contains('pcoded-hasmenu')) {
            if (!parent.classList.contains('pcoded-trigger')) {
              parent.classList.add('pcoded-trigger');
            }
          }
        } while (parent);
      }
      const navbar = document.querySelector('app-navigation.pcoded-navbar');
      if (navbar?.classList.contains('mob-open')) {
        navbar.classList.remove('mob-open');
      }
    } else {
      setTimeout(() => {
        const sections = document.querySelectorAll('.pcoded-hasmenu');
        for (let i = 0; i < sections.length; i++) {
          sections[i].classList.remove('active');
          sections[i].classList.remove('pcoded-trigger');
        }

        let current_url = this.location.path();
        if (this.location['_baseHref']) {
          current_url = this.location['_baseHref'] + this.location.path();
        }
        const link = "a.nav-link[ href='" + current_url + "' ]";
        const element = document.querySelector(link);
        if (element !== null && element !== undefined) {
          const parent = element.parentElement;
          const up_parent = parent.parentElement.parentElement;
          const last_parent = up_parent.parentElement;
          if (parent.classList.contains('pcoded-hasmenu')) {
            parent.classList.add('active');
          } else if (up_parent.classList.contains('pcoded-hasmenu')) {
            up_parent.classList.add('active');
          } else if (last_parent.classList.contains('pcoded-hasmenu')) {
            last_parent.classList.add('active');
          }
        }
      }, 500);
    }
  }

  // Show native title tooltip only when sidebar is closed
  get showTitle(): boolean {
    const navbar = document.querySelector('.pcoded-navbar');
    // Consider tooltip visible only when navbar is explicitly collapsed
    return !!(navbar && navbar.classList.contains('navbar-collapsed'));
  }

}
